<ul>
    <ng-container *ngTemplateOutlet="menuTmpl; context: { $implicit: menu }" />
</ul>

<ng-template #menuTmpl let-items>
    <ng-container *ngFor="let item of items">
        <ng-container *ngIf="!item.requiresUnrestricted || permissionService.isUnrestricted()">
            <li *appHasPermissions="item.permissions">
                <a
                    *ngIf="!item?.children?.length"
                    [routerLink]="item?.route"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: item.exactMatch ?? false }"
                    [appTooltip]="item.translationKey | translate"
                    [tooltipDisabled]="!collapsed"
                    tooltipPosition="right"
                >
                    <div>
                        <span class="material-symbols-rounded">{{ item.icon }}</span>
                    </div>
                    <span class="label">{{ item.translationKey | translate }}</span>
                </a>
                <ng-container *ngIf="item?.children?.length">
                    <h3
                        [appTooltip]="item.translationKey | translate"
                        [tooltipDisabled]="!collapsed"
                        tooltipPosition="right"
                    >
                        <div>
                            <span class="material-symbols-rounded">{{ item.icon }}</span>
                        </div>
                        <span class="label">{{ item.translationKey | translate }}</span>
                    </h3>
                    <ul>
                        <ng-container *ngTemplateOutlet="menuTmpl; context: { $implicit: item.children }" />
                    </ul>
                </ng-container>
            </li>
        </ng-container>
    </ng-container>
</ng-template>
